import React from 'react';
import imageUrlBuilder from '@sanity/image-url';

import { styled } from '@tmap/mmm-style-guide/src/styled';

import client from '../../../client';

const builder = imageUrlBuilder(client);

const imgStyles = ({ }) => ({
  width: '100%',
  objectFit: 'cover',
  borderRadius: '8px',
});
const StyledPicture = styled('picture')(imgStyles);
const StyledImg = styled('img')(imgStyles);

export const ImagePreview = ({ image, altText }) => (<StyledPicture>
  <source srcSet={builder.image(image).format('webp').width(105).height(84).url()} width={105} height={84} />
  <StyledImg src={builder.image(image).format('webp').width(105).height(84).url()} width={105} height={84}
    alt={altText}
  />
</StyledPicture>);
